import { useOutletContext } from 'react-router-dom'

import { useCurrentPlayerLeaderBoardQuery } from '../__generated__/hooks'
import LeaderboardView from '../components/Leaderboard'
import type { CurrentPlayerCtx } from '../PlayerShell'

/**
 * Authenticated player's leaderboard tab (Topp / Leaderboard). Wraps the shared
 * LeaderboardView with player-key auth and self-highlight.
 */
const Leaderboard = () => {
  const { player } = useOutletContext<{ player: CurrentPlayerCtx }>()
  const { data, loading, error } = useCurrentPlayerLeaderBoardQuery({
    fetchPolicy: 'cache-and-network',
    pollInterval: 10_000,
  })

  if (loading && !data) {
    return (
      <section className="px-4 py-8 text-center text-ink-500">
        Laster leaderboard…
      </section>
    )
  }
  if (error) {
    return (
      <section className="px-4 py-8 text-center text-flag">
        Kunne ikke laste leaderboardn.
      </section>
    )
  }

  return (
    <LeaderboardView
      leaderboard={data?.currentPlayerLeaderBoard ?? null}
      youId={player.id}
      yourTeamId={player.team?.id ?? null}
      ranking={player.polfEvent.ranking}
      courseHoles={player.polfEvent.course.holes}
    />
  )
}

export default Leaderboard
